/**
 * Toggle the targets visibility
 */

$(document).on("click", "[data-behavior~=toggle-target]", function() {
  var target = $("[data-type~= " + $(this).data("toggle-target") + "]");
  $(target).slideToggle();
});
